<template>
  <FormItem :label="(label || 'label') + ':'" class="search-formItem">
    <DatePicker size="small"
                @on-change="changeValue"
                format="yyyy/MM/dd"
                type="daterange"
                v-model="dataValue"
                placement="bottom-end" :placeholder="placeholder" style="width: 200px"></DatePicker>
  </FormItem>
</template>

<script>
export default {
  name: 'search-form-item-date',
  model: {
    prop: 'value',
    event: 'change'
  },
  props: {
    label: String,
    placeholder: String,
    value: {
      type: String | Number,
      default: ''
    },
    list: {
      type: Array,
      default: () => {
        return []
      }
    }
  },
  data () {
    return {
      dataValue: ''
    }
  },
  created () {
    this.dataValue = this.value
    console.log(this.list)
  },
  methods: {
    changeValue (e) {
      this.$emit('on-change', e);
    }
  },
  watch: {
    value (val) {
      console.log("---------------11--1-1-1")
      this.dataValue = val
    }
  }
}
</script>

<style lang="less">
.search-formItem {
  width: 32%;
  margin-top: 10px;
  margin-bottom: 0;
}
</style>
